import { Action } from "redux"
import { action } from "typesafe-actions"

export enum ActionTypes {
    LOGIN_URL_UPDATED = "LOGIN_URL_UPDATED",
    LOGIN_INITIATED = "LOGIN_INITIATED",
    AUTH_URL_RECIEVED = "AUTH_URL_RECIEVED",
    AUTH_URL_ERROR = "AUTH_URL_ERROR",
    LOGIN_CALLBACK = "LOGIN_CALLBACK",
    LOGIN_CALLBACK_ERROR = "LOGIN_CALLBACK_ERROR",
    LOGIN_CALLBACK_SUCCESS = "LOGIN_CALLBACK_SUCCESS",
    SESSION_CHECK_INITIATED = "SESSION_CHECK_INITIATED",
    SESSION_CHECK_SUCCESS = "SESSION_CHECK_SUCESS",
    SESSION_CHECK_ERROR = "SESSION_CHECK_ERROR"
}

export interface ActionPayload extends Action<ActionTypes> {
    payload: {
        loginURL: string
        authURL: string
        user: User
    }
}


interface User {
    name: string
    url: string
    photo: string
}

// form updating
export const updateLoginURL = (url: string) => action(ActionTypes.LOGIN_URL_UPDATED, { loginURL: url })


// api calls :: init / success / error
export const initiateLogin = (url: string) => action(ActionTypes.LOGIN_INITIATED, { loginURL: url })
export const authURLRecieved = (url: string) => action(ActionTypes.AUTH_URL_RECIEVED, { authURL: url });
export const initiateLoginError = () => action(ActionTypes.AUTH_URL_ERROR);

export const loginCallback = () => action(ActionTypes.LOGIN_CALLBACK);
export const loginCallbackError = () => action(ActionTypes.LOGIN_CALLBACK_ERROR);
export const loginCallbackSuccess = (user: User) => action(ActionTypes.LOGIN_CALLBACK_SUCCESS, { user: user });

export const initSessionCheck = () => action(ActionTypes.SESSION_CHECK_INITIATED);
export const sessionCheckSuccess = (user: User) => action(ActionTypes.SESSION_CHECK_SUCCESS, { user: user });
export const sessionCheckError = () => action(ActionTypes.SESSION_CHECK_ERROR);
